export const valueHasData = (value) => value != null && value.toString().trim().length > 0;

export const numberBetween = (value, min, max) =>
  Number(value.toString().trim()) >= min && Number(value.toString().trim()) <= max;
